import { TrackByFunction } from '@angular/core';
import { BasketLine } from '@core/services/basket/basket.model';
import { ProductDetailViewModel } from '@models/api-search.models';
import { OrderLineViewModel } from '@models/api-orders.models';

export const trackByVariantNo: TrackByFunction<BasketLine> = (_, line) => line.variantNo;
export const trackItemByVariantNo: TrackByFunction<ProductDetailViewModel> = (_, product) => product.variantNo;
export const trackOrderItemByVariantNo: TrackByFunction<OrderLineViewModel> = (_, line) => line.variantNo;
